import React from "react";

import { formatDateTime } from "shared/utils";
import { MutedDarkText, TinyText } from "shared/styles";
import { copy } from "shared/assets/copy";
const {
  venuePage: {
    view: { lastUpdated },
  },
} = copy;

interface LastUpdatedInfoProps {
  time: string;
}

export const LastUpdatedInfo: React.FC<LastUpdatedInfoProps> = ({ time }) => (
  <TinyText as={MutedDarkText}>
    {lastUpdated}: {formatDateTime(time)}
  </TinyText>
);
